import getPolicy from './getPolicy';
import setPolicy from './setPolicy'

export default { setPolicy, getPolicy };
